<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <circle cx="12" cy="12" r="8" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4C14.5 6.5 14.5 17.5 12 20" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M4 12C6.5 9.5 17.5 9.5 20 12" />
  </svg>
</template>
